import React from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { SignOut } from '@phosphor-icons/react';
import { useAuth } from '../../contexts/AuthContext';
import { HaleWordmark } from '../HaleBrand';
import TI from '../brand/TI';
import { T, FONT } from '../../pages/hale-console/_theme';

/* HaleAdminLayout — Hale-branded reviewer/admin shell for the Hale
 * Reviewed module. No ToxIntel chrome. Nav mirrors the Hale admin spec;
 * items not yet built (Phase 2+) are shown muted with a "soon" tag. */

const NAV = [
  { label: 'Console',       to: '/hale/console' },
  { label: 'Applications',  to: '/hale/console#applications' },
  { label: 'Brands',        soon: true },
  { label: 'Products',      to: '/admin/hale-reviewed' },
  { label: 'Hale Reviewed', to: '/admin/hale-reviewed' },
  { label: 'Documents',     soon: true },
  { label: 'Marketplace',   soon: true },
];

export default function HaleAdminLayout({ children }) {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = async () => { await logout(); navigate('/hale/login', { replace: true }); };

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: T.NEUTRAL, color: T.INK, fontFamily: FONT.BODY }}>
      <header className="sticky top-0 z-40" style={{ backgroundColor: 'rgba(255,255,255,0.94)', backdropFilter: 'blur(10px)', borderBottom: `1px solid ${T.LINE}` }}>
        <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center gap-4">
          <Link to="/hale/console" className="flex items-center gap-2 flex-shrink-0" data-testid="hale-admin-brand">
            <HaleWordmark size="sm" />
            <span className="hidden sm:inline text-[10px] uppercase tracking-[0.2em] px-2 py-1 rounded" style={{ backgroundColor: T.INK, color: T.WHITE, fontFamily: FONT.MONO }}>Console</span>
          </Link>
          <nav className="flex-1 flex items-center gap-1 overflow-x-auto no-scrollbar">
            {NAV.map((n) => n.soon ? (
              <span key={n.label} className="px-3 py-2 text-[12.5px] font-medium whitespace-nowrap inline-flex items-center gap-1.5" style={{ color: '#B5B5BC' }}>
                {n.label}<span className="text-[8px] uppercase tracking-wider px-1 py-0.5 rounded" style={{ backgroundColor: T.LINE, color: T.MUTED, fontFamily: FONT.MONO }}>soon</span>
              </span>
            ) : (
              <NavLink key={n.label} to={n.to} end={n.to === '/admin/hale-reviewed'}
                data-testid={`hale-admin-nav-${n.label.toLowerCase().split(' ')[0]}`}
                className="px-3 py-2 rounded-md text-[12.5px] font-medium whitespace-nowrap"
                style={({ isActive }) => ({ color: isActive ? T.INK : T.MUTED, backgroundColor: isActive ? 'rgba(230,57,70,0.08)' : 'transparent' })}>
                {n.label}
              </NavLink>
            ))}
          </nav>
          <button onClick={handleLogout} data-testid="hale-admin-logout" className="flex-shrink-0 inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg text-[12px] font-semibold border" style={{ borderColor: T.LINE, color: T.INK, backgroundColor: T.WHITE }}>
            <SignOut size={14} weight="bold" /> <span className="hidden sm:inline">Logout</span>
          </button>
        </div>
      </header>

      <main className="flex-1 max-w-7xl w-full mx-auto px-5 sm:px-8 py-10">{children}</main>

      <footer style={{ borderTop: `1px solid ${T.LINE}`, backgroundColor: T.WHITE }}>
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <span className="text-[10px] uppercase tracking-[0.2em]" style={{ color: T.MUTED, fontFamily: FONT.MONO }}>Hale Reviewed · operations</span>
          <span className="text-[10px] uppercase tracking-[0.18em]" style={{ color: T.MUTED, fontFamily: FONT.MONO }}>Scientific engine · <TI color={T.PINK} /> + Aᴳ</span>
        </div>
      </footer>
    </div>
  );
}
